'use client';

import { apiRoutes, publicHttpClient } from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import type { VerifyOTPError } from './use-verify-otp-mutation';

export interface ForgotPasscodeResponse {
  is_sent: boolean;
  created_time: number;
}

export interface ForgotPassCode {
  mobile: string;
}

export const forgotPasscodeFn = async (body: ForgotPassCode) => {
  const response = await publicHttpClient.post<ForgotPasscodeResponse>(
    apiRoutes.auth.forgotPasscode,
    {
      country_code: 'VN',
      ...body,
    }
  );
  return response.data;
};

export const useForgotPasscodeMutation = (
  opts?: UseMutationOptions<
    ForgotPasscodeResponse,
    VerifyOTPError,
    ForgotPassCode
  >
) =>
  useMutation<ForgotPasscodeResponse, VerifyOTPError, ForgotPassCode>({
    mutationFn: forgotPasscodeFn,
    ...opts,
  });
